module.exports = __webpack_public_path__ + "img/app.246ca80c.svg";